import { render } from "./OrderResult.vue?vue&type=template&id=4570e54c"
const script = {}

import "./OrderResult.vue?vue&type=style&index=0&id=4570e54c&lang=scss"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__